import React from 'react';
import PropTypes from 'prop-types';
import { setClassNames } from '@ddc/classnames-js';
import { formatCurrency } from 'ddc-intl';
import Payment from './Payment';
import PaymentError from './PaymentError';

const PaymentSelectOption = ({
	id,
	paymentAmount,
	term,
	paymentTypeLabel,
	firstItem = false,
	lastItem = false,
	isSelected = false,
	hasSpecial = false,
	onSelect = () => {},
	isLoading = false,
	dataPreloadAttr = null,
	hasTaxesAndFees = false,
	hasError = false
}) => {
	const middleItem = !firstItem && !lastItem;
	const showBorder = !lastItem && !isSelected && !isLoading;

	const containerClasses = [
		'position-relative',
		'payment-option-container',
		'py-3',
		'd-flex',
		'border', // this is to ensure there is no movement in center option
		'justify-content-center',
		firstItem && 'border-left',
		firstItem && 'rounded-left',
		firstItem && 'left-option',
		lastItem && 'border-right',
		lastItem && 'rounded-right',
		lastItem && 'right-option',
		middleItem && 'middle-option',
		!isSelected && 'border-top border-bottom'
	];

	const containerStyles = {
		flex: '1 1 0px'
	};

	if (isLoading) {
		containerClasses.push('skeleton-shimmer');
		containerClasses.push('rounded');
	} else if (isSelected) {
		containerClasses.push('selected border rounded');
	} else {
		containerClasses.push('transparent');
	}

	return (
		<>
			<div
				className={setClassNames(containerClasses)}
				style={containerStyles}
			>
				{!isLoading ? (
					<>
						{hasSpecial && (
							<i
								className="rounded-circle ddc-icon ddc-icon-tag-circle ddc-font-size-large position-absolute  specials-tag text-primary p-0"
								role="presentation"
								aria-hidden="true"
							/>
						)}
						<label
							htmlFor={`payment_option_${id}_input`}
							className="my-0 font-weight-normal w-100"
						>
							<div className="d-flex flex-row justify-content-center mt-1">
								<input
									type="radio"
									className="mt-0 mr-2"
									id={`payment_option_${id}_input`}
									value={paymentTypeLabel}
									name="paymentSelection"
									checked={isSelected}
									onChange={() => onSelect(id)}
								/>
								<span className="ddc-font-size-small">
									{paymentTypeLabel}
								</span>
							</div>
							<div className="text-center">
								{hasError ? (
									<PaymentError />
								) : (
									<Payment
										payment={formatCurrency(paymentAmount)}
										hasTerm={!!term}
										dataPreloadAttr={dataPreloadAttr}
										hasTaxesAndFees={hasTaxesAndFees}
										paymentType={paymentTypeLabel}
									/>
								)}
							</div>
						</label>
					</>
				) : (
					<div className="loading-spacer" />
				)}
			</div>
			{showBorder && <div className="inset-border" />}
		</>
	);
};

PaymentSelectOption.propTypes = {
	id: PropTypes.number.isRequired,
	paymentAmount: PropTypes.number.isRequired,
	paymentTypeLabel: PropTypes.string.isRequired,
	term: PropTypes.string,
	firstItem: PropTypes.bool,
	lastItem: PropTypes.bool,
	isSelected: PropTypes.bool,
	onSelect: PropTypes.func.isRequired,
	hasSpecial: PropTypes.bool,
	isLoading: PropTypes.bool,
	dataPreloadAttr: PropTypes.string,
	hasTaxesAndFees: PropTypes.bool,
	hasError: PropTypes.bool
};

export default PaymentSelectOption;
